import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

import { Button } from "antd";
import { Header } from "components";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    // On veut que cette page se cache lorsqu'on navigue
    // par la suite.
    const { history } = this.props;
    this.unlisten = history.listen((location, action) => {
      if (this.state.hasError) this.setState({ hasError: false });
    });

    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="home-page main-content">
          <Header title="Une erreur s'est produite" />
          <div className="error-display">
            <p>Contacter les administrateurs si cette erreur persiste.</p>
            <Button icon="home" type="primary" size="large" href="#/">
              Retour à l'accueil
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
